import { useCallback } from 'react'
import { useSelector } from 'react-redux'

/**
 * Hook to return authorization flags
 */
const useAuthorization = () => {
  const selectedCustomer = useSelector(({ customers }) => customers?.selectedCustomer)

  // org subscriptions
  const hasEngageAutopilotSubscription = useSelector(({ meta }) => meta.hasEngageAutopilotSubscription)
  const hasIntuneSubscription = useSelector(({ meta }) => meta.hasIntuneSubscription)

  // nfr licenses
  const hasNfrEngageEssentialsLicense = selectedCustomer?.hasNfrEngageEssentialsLicense

  // licenses
  const licenses = useSelector((state) => state.licenses.data)

  const hasLicenses = useCallback(
    (licenseNames) => licenseNames.some((name) => licenses?.[name]?.hasLicense),
    [licenses],
  )

  // feature flags
  const featureFlags = useSelector(({ featureFlags }) => featureFlags.data) // eslint-disable-line no-shadow
  const isEngageAutopilotFlagEnabled = featureFlags?.find((item) => item.feature === 'engage-autopilot')?.enabled
  const isIntuneFreeTrialEnabled = featureFlags?.find((item) => item.feature === 'intune-free-trial')?.enabled

  return {
    isAuthorizedForEngageAutopilot:
      isEngageAutopilotFlagEnabled && (hasEngageAutopilotSubscription || hasNfrEngageEssentialsLicense),
    isAuthorizedForIntune: hasIntuneSubscription || isIntuneFreeTrialEnabled,
    isAuthorizedForDiscover: hasLicenses(['discover-essentials', 'discover-premium', 'nfr-discover-essentials']),
  }
}

export default useAuthorization
